import {Injectable} from '@angular/core';
import {Config} from '../../shared/services/config.service';

export type EnvironnementNameEnum = 'prod' | 'preprod';

export const EnvironnementNameEnum = {
  prod: 'prod' as EnvironnementNameEnum,
  preprod: 'preprod' as EnvironnementNameEnum
};

@Injectable()
export class EnvironnementProvider {
  private readonly _production: any;
  private readonly _preproduction: any;
  private readonly _web: boolean;
  private _default: any;

  constructor(private readonly config: Config) {
    this._production = config.getConfig('environnement')[EnvironnementNameEnum.prod];
    this._preproduction = config.getConfig('environnement')[EnvironnementNameEnum.preprod];
    this._default = config.getConfig('environnement').mode === 'production' ? EnvironnementNameEnum.prod : EnvironnementNameEnum.preprod;
    this._web = config.getConfig('web');
  }

  get production(): any {
    return this._production;
  }

  get preproduction(): any {
    return this._preproduction;
  }

  get default(): any {
    switch (this._default) {
      case EnvironnementNameEnum.prod:
        return this._production;
      case EnvironnementNameEnum.preprod:
        return this._preproduction;
    }
  }

  set default(value: any) {
    this._default = value as EnvironnementNameEnum;
  }

  defaultName(): string {
    return this._default;
  }

  isPreproduction(): boolean {
    return EnvironnementNameEnum.preprod === this._default ;
  }

  isSiteWeb(): boolean {
    return this._web;
  }
}



// WEBPACK FOOTER //
// ./src/core/app/environnement-provider.service.ts